import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function AddDebitNote() {
  const [amount, setAmount] = useState("");
  const [issueDate, setIssueDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [userRole, setUserRole] = useState("");
  const [userName, setUserName] = useState("");
  const [organizations, setOrganizations] = useState([]);
  const [currentUser, setCurrentUser] = useState("");
  const [locations, setLocations] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [selectedSupplierName, setSelectedSupplierName] = useState(null);
  const [reason, setReason] = useState("");
  const [invoices, setInvoices] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const invoicesPerPage = 8;

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          toast.error("Authentication token is missing. Please log in again.");
          return;
        }

        const userResponse = await axios.get(`${API_BASE_URL}/users/specific`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const userData = userResponse.data;
        setUserRole(userData.role);
        setUserName(userData.username);
        setCurrentUser(userData);

        if (userData.role === "Main Admin") {
          const orgResponse = await axios.get(`${API_BASE_URL}/organizations`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setOrganizations(orgResponse.data.organizations || []);
        }

        const supplierResponse = await axios.get(
          `${API_BASE_URL}/suppliers/get`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setSuppliers(supplierResponse.data.suppliers || []);
        console.log(supplierResponse)
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Failed to fetch user or supplier data.");
      }
    };

    fetchUserData();
  }, []);

  const handleAddDebitNote = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Authentication token is missing. Please log in again.");
      return;
    }

    if (!selectedSupplier || !amount || !issueDate || !reason) {
      toast.error("Please fill in all required fields.");
      return;
    }

    try {
      const payload = {
        issueDate,
        supplier_id: selectedSupplier,
        reason,
        created_by: currentUser._id,
        amount: Number(amount),
        invoices: selectedInvoice
          ? [
              {
                invoice_id: selectedInvoice,
                debit_applied: Number(amount),
              },
            ]
          : [],
      };

      const response = await axios.post(
        `${API_BASE_URL}/debitNotes/add`, 
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 201) {
        toast.success("Debit note added successfully!");
        setAmount("");
        setSelectedSupplier(null);
        setSelectedSupplierName(null);
        setSelectedInvoice(null);
        setReason("");
      }
    } catch (error) {
      console.error("Error adding debit note:", error);
      toast.error(
        error.response?.data?.message || "Failed to add debit note."
      );
    }
  };

  const customSupplierIDSelect = () => (
    <Select
      options={suppliers}
      getOptionLabel={(e) => e.supplier_code}
      getOptionValue={(e) => e._id}
      isSearchable={true}
      placeholder="Search by Supplier ID"
      className="w-full"
      value={suppliers.find((option) => option._id === selectedSupplier) || null}
      onChange={(option) => {
        setSelectedSupplier(option?._id);
        setSelectedSupplierName(option?.supplier_name);
      }}
    />
  );

  const customSupplierNameSelect = () => (
    <Select
      options={suppliers}
      getOptionLabel={(e) => e.supplier_name}
      getOptionValue={(e) => e._id}
      isSearchable={true}
      placeholder="Search by Supplier Name"
      className="w-full"
      value={
        suppliers.find(
          (option) => option.supplier_name === selectedSupplierName
        ) || null
      }
      onChange={(option) => {
        setSelectedSupplier(option?._id);
        setSelectedSupplierName(option?.supplier_name);
      }}
    />
  );

  return (
    <div className="container mx-auto p-6">
      <div className="bg-white rounded-lg shadow-lg p-6 mt-4">
        <h2 className="text-2xl font-bold text-blue-700 mb-6">
          Add Debit Note
        </h2>

        <div className="grid grid-cols-2 gap-6 mb-6">
          <div>
            <label className="block text-gray-700 mb-2">Supplier ID</label>
            {customSupplierIDSelect()}
          </div>
          <div>
            <label className="block text-gray-700 mb-2">Supplier Name</label>
            {customSupplierNameSelect()}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-6 mb-6">
          <div>
            <label className="block text-gray-700 mb-2">
              Amount Debited (LKR)
            </label>
            <input
              type="number"
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter debit amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          </div>
          <div>
            <label className="block text-gray-700 mb-2">Issue Date</label>
            <input
              type="date"
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={issueDate}
              onChange={(e) => setIssueDate(e.target.value)}
            />
          </div>
        </div>

        <div className="mb-6">
          <label className="block text-gray-700 mb-2">Reason</label>
          <textarea
            className="w-full p-3 border rounded-lg"
            rows="6"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason for debit note..."
          ></textarea>
        </div>

        <div className="flex justify-end mt-6">
          <button
            className="bg-blue-700 text-white px-6 py-3 rounded-lg hover:bg-blue-800"
            onClick={handleAddDebitNote}
          >
            Add Debit Note
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddDebitNote;
